export default __webpack_public_path__ + "static/media/card-guide.f8624dff.png";